import {MiniMarketLevel} from './mini-market-level';

export class MiniMarket {
    id: number;
    isActive: boolean;
    name: string;
    code: string;
    marketLevel: MiniMarketLevel;
    parents: MiniMarket[] = [];
}